import React from 'react';
import PropTypes from 'prop-types';
import {
  AnalyticsContext,
  ErrorLoggingContext,
  TranslationContext,
  BranchContext
} from '@strava/container-context';

/**
 * This is Mocking the Contexts that exist in Active for when you run your microfrontend locally. They are not used in production versions of MFEs
 * https://github.com/strava/active/blob/main/app/javascript/apps/Microfrontend/Microfrontend.js#L315-L317
 *
 * Read: https://github.com/strava/web/blob/main/microfrontends/README.md#Mocked-Context
 */
const MockedContextProvider = ({
  children,
  analyticsContextValue,
  translationContextValue,
  errorLoggingContextValue,
  branchContextValue
}) => {
  return (
    <AnalyticsContext.Provider
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      value={{ track: () => {}, ...analyticsContextValue }}
    >
      <TranslationContext.Provider
        value={{
          t: (key) => {
            return key;
          },
          getLanguage: () => {
            return 'en-US';
          },
          ...translationContextValue
        }}
      >
        <ErrorLoggingContext.Provider
          // eslint-disable-next-line no-console
          value={{
            logError: (e) => console.error(e),
            ...errorLoggingContextValue
          }}
        >
          <BranchContext.Provider
            value={{
              isProcessing: false,
              createLink: () => Promise.resolve('mock_branch_link'),
              ...branchContextValue
            }}
          >
            {children}
          </BranchContext.Provider>
        </ErrorLoggingContext.Provider>
      </TranslationContext.Provider>
    </AnalyticsContext.Provider>
  );
};

MockedContextProvider.defaultProps = {
  analyticsContextValue: {},
  translationContextValue: {},
  errorLoggingContextValue: {}
};

MockedContextProvider.propTypes = {
  children: PropTypes.shape().isRequired,
  analyticsContextValue: PropTypes.shape(),
  translationContextValue: PropTypes.shape(),
  errorLoggingContextValue: PropTypes.shape()
};

export default MockedContextProvider;
